// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const F5Icon = createSvgIcon(
  <svg width={24} height={24} viewBox="0 0 44.4 44.4">
    <circle cx={22.2} cy={22.2} r={22.2} fill="#E21D38" />
    <path
      fill="#FFF"
      d="M21.69 24.39c10.9.9 15.1 3.9 14.9 8-.2 2.2-2.3 4.3-5 4.5-3.2.2-4.7-1.1-5.6-2.5-.8-1.3-1.7-2.6-2.6-4-.2-.4-.6-.1-.9.1-.7.6-1.3 1.3-1.9 1.9-.4.4-.3.7-.2 1 .6 1.4 1.2 2.8 1.8 4.1 1 .6 5.5 1.4 8.8 1.1 2.3-.2 5.1-1.1 7.5-2.8 2.3-1.8 4-4.2 4.3-8.1.1-2.4-.3-4.9-2.4-7.2s-5.7-4.2-13-4.7c.4-1.2.7-2.3 1.1-3.4 4.4.2 8.3.5 11.6.9.3-1.3.4-2.5.7-3.7l-.9-1.1c-1.7-.2-3.3-.6-5.1-.8-2.3-.3-4.7-.5-7.3-.6-1.7 4.8-3.7 10.9-5.8 17.3m-2.9-18.7c-.8 0-1.9.2-3.7.6-3.9 1.1-8.7 3.8-9.2 8.3-.1.7-.1 1.5-.2 2.2l-3.1.3c-.1.9-.1 1.7-.2 2.6 1-.1 2-.1 3.1-.2-.2 4.7 0 9.4.4 13.8.1.7.1 1.3.1 1.7-.1.4-.8.6-1.8.6l1.3 1.6c3.8.7 8.6 1.2 13.7 1.3v-1.5c-3-.2-4.4-.6-4.6-1.2-.2-.5-.2-1.2-.3-1.9-.2-4.6-.3-9.6-.2-14.7 1.7 0 3.4 0 5.1-.1.9-.4 1.7-.8 2.5-1.2v-1.7c-2.6 0-5.1.1-7.6.1l.3-6c.1-1.3 1-2.2 1.8-2.2 1.4-.1 2.7.5 4 1.1.7.3 1.4.7 2.1 1 .3.1.7.2 1-.1.4-.5.8-1 1.2-1.4.2-.3.1-.5 0-.6l-2.6-2c-.5-.4-1.4-.4-2.2-.4-.3-.1-.6 0-.9 0"
    />
  </svg>,
  "F5",
);
export default F5Icon;
